<template>
  <div id="about">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%;box-shadow: 0px 0px 1px 1px gray;"></div>
    <!--轮播-->
<!--    <div class="block">-->
<!--      <el-carousel height="550px" interval="5000">-->
<!--        &lt;!&ndash;<el-carousel-item v-for="item in banner" :key="item.index">&ndash;&gt;-->
<!--          &lt;!&ndash;<span @click="windowOpen(item.url)">&ndash;&gt;-->
<!--            &lt;!&ndash;<img :src="item.picture">&ndash;&gt;-->
<!--          &lt;!&ndash;</span>&ndash;&gt;-->
<!--        &lt;!&ndash;</el-carousel-item>&ndash;&gt;-->
<!--        <el-carousel-item>-->
<!--          <span>-->
<!--             <img src="@/assets/images/banner1.png">-->
<!--          </span>-->
<!--        </el-carousel-item>-->
<!--        <el-carousel-item>-->
<!--          <span>-->
<!--             <img src="@/assets/images/homebg.jpg">-->
<!--          </span>-->
<!--        </el-carousel-item>-->
<!--        <el-carousel-item>-->
<!--          <span>-->
<!--             <img src="@/assets/images/banner1.png">-->
<!--          </span>-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </div>-->
    <!--锚点-->
    <div class="about-nav">
      <!--<div class="main">-->
        <!--<div class="link-content">-->
          <!--<ul>-->
            <!--<li><a href="#1">快点简介</a></li>-->
            <!--<li><a href="#2">快点团队</a></li>-->
            <!--<li><a href="#3">合作伙伴</a></li>-->
            <!--<li><a href="#4">发展历程</a></li>-->
            <!--<li><a href="#5">加入我们</a></li>-->
          <!--</ul>-->
        <!--</div>-->
      <!--</div>-->
    </div>
    <!--<div class="fixed-about-block"></div>-->
    <!--内容-->
    <div class="main">
      <!--锚点内容-->
      <div class="about-contain">
        <el-row id="1" class="row-bg">
          <el-col :span="24" class="left">
            <h3 class="about-title">快点简介</h3>
          </el-col>
          <el-col :span="24" class="about-content">
<!--            <el-col :span="6">-->
<!--              <img src="@/assets/images/images01/fast_logo.jpg">-->
<!--            </el-col>-->
            <el-col :span="23" :offset="1">
              <p>快点打印，为您提供最稳定、高效的打印解决方案。</p>
              <p>世代传承的意志，时代的变迁，人的梦想，这些都是挡不住的。只要人们继续追寻自由的答案，这一切，都将永不停止。</p>
            </el-col>
          </el-col>
        </el-row>
        <el-row id="2" class="row-bg">
          <el-col :span="24">
            <h3 class="about-title">快点合伙人</h3>
          </el-col>
          <el-col :span="24" class="about-content">
<!--            <div class="team-contain" v-for="item in teamUsers" :key="item.index">-->
<!--              <img class="person-box" :src="item.headicon"/>-->
<!--              <article class="team-introduce">-->
<!--                <label>{{item.nick}}</label>-->
<!--                <p>{{item.name}}</p>-->
<!--                <small>{{item.position}}</small>-->
<!--                <div class="team-des"><span>{{item.des}}</span></div>-->
<!--              </article>-->
<!--            </div>-->
            <div class="uses" style="">
              <el-row :gutter="30">
                <el-col :span="8" v-for="(item,index) in teamList" :key="index">
                  <el-col  class="user" style="padding: 10px 0px;margin-bottom: 35px">
                  <el-col :span="8">
                    <!--<img style="border-radius: 50%" src="@/assets/images/teams/3.png"/>-->
                    <img style="border-radius: 50%" :src="'http://ad.kdslow.com/api/'+item.headUrl"/>
                  </el-col>
                  <el-col :span="16">
                      <el-col :span="24" style="padding: 0px;margin: 0px;margin-top: 5px;font-family: SimHei">
                        <span style="font-size: 20px"> {{item.nick}}</span>
                        <span style="font-size: 12px"> {{item.name}}</span>
                        <span class="position" style="font-size: 12px;margin-left: 10px"> {{item.remark}}</span>
                      </el-col>
                      <el-col :span="24" style="font-size: 12px;margin-top: 10px;padding: 0px;font-family: SimHei">{{item.des}}</el-col>
                  </el-col>
                </el-col>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <!--<el-row id="3" class="row-bg">-->
          <!--<el-col :span="24">-->
            <!--<h3 class="about-title">合作伙伴</h3>-->
          <!--</el-col>-->
          <!--<el-col :span="24" class="about-content">-->
            <!--<p>武汉先知科技有限公司是一家专业从事互联网产品研发、企业系统开发的高新技术企业。拥有一批长期从事互联网开发和企业服务的专业人才，具有雄厚的技术开发实力，能够全方位满足客户与企业信息化的需求。</p>-->
            <!--<p>武汉先知科技有限公司在发展过程中，曾先后荣获“AAA级信用企业认证”、“高新企业资质认证”、“汉口学院人才实训基地”等荣誉资质以及6项计算机软著权。</p>-->
            <!--<p>先知科技经过多年的经验积累，总结出针对各个行业、不同规模和不同阶段的企业信息化解决方案，我们的项目实施团队能够准确快捷的发掘客户需求，为客户量身定制真正切合实际需求的解决方案。</p>-->
            <!--<p>-->
              <!--目前公司专注于互联网+科协、互联网+工会、综合电商平台、电梯管理系统、软件定制化的研究和开发，先后研发出宜昌市“互联网+科协”综合管理平台、宜昌市科学技术协会门户网站、湖北省科协网上办事服务大厅、湖北省科协智库建设网络信息平台、湖北省科协网上办事服务大厅综合管理平台、湖北科协官方微信订阅号、宜昌市总工会职工服务网、襄阳市总工会职工服务网、电梯综合管理系统、标识行业生态圈B2B电子商务平台等一系列精品软件平台。</p>-->
          <!--</el-col>-->
        <!--</el-row>-->
        <!--<el-row id="4" class="row-bg">-->
          <!--<el-col :span="24">-->
            <!--<h3 class="about-title">发展历程</h3>-->
          <!--</el-col>-->
          <!--<el-col :span="24" class="about-content">-->
            <!--<img src="@/assets/images/map.png" style="width:80%;margin-bottom: 20px;border: none">-->
            <!--<span style="display: inline-block;font-size: 20px;line-height: 40px">快点打印已覆盖武汉、深圳等全国一百多个城市</span>-->
          <!--</el-col>-->
        <!--</el-row>-->
<!--        <el-row id="5" class="row-bg">-->
<!--          <el-col :span="24">-->
<!--            <h3 class="about-title">加入我们</h3>-->
<!--          </el-col>-->
<!--          <el-col :span="24" class="about-content">-->
<!--            <p>贵州快点在线科技有限公司立志做打印行业领军者，欢迎志同道合的你加入我们</p>-->
<!--            <p>我们期待你拥有以下技能之一:&nbsp;&nbsp;&nbsp;&nbsp;打印机故障处理、合作渠道、业务推广能力、java工程师、前端工程师、windows工程师</p>-->
<!--            <p></p>-->
<!--            <p>联系方式：kuaidian@kdslow.com </p>-->
<!--          </el-col>-->
<!--        </el-row>-->
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      banner: [],
      teamUsers: [
        {
          name: '林志辉',
          nick: '箱男',
          position: 'CEO',
          headicon: './static/teamimgs/1.png',
          des: '有什么理由能阻止一个男人扬帆起航？'
        }, {
          name: '石桥',
          nick: '红发',
          position: 'COO',
          headicon: './static/teamimgs/2.png',
          des: '既然选择了远方，便只顾风雨兼程'
        }, {
          name: '张浩龙',
          nick: '庸医',
          position: 'CFO',
          headicon: './static/teamimgs/3.png',
          des: '我们的征途是星辰大海'
        }, {
          name: '王龙',
          nick: '鬼彻',
          position: 'CTO',
          headicon: './static/teamimgs/4.png',
          des: '梦想虽然遥不可及，但不是不可能实现。只要足够的强。'
        }, {
          name: '张朝国',
          nick: '艾斯',
          position: 'CIO',
          headicon: './static/teamimgs/5.png',
          des: '先相信你自己，然后别人才会相信你'
        }, {
          name: '陈建芳',
          nick: '火药星',
          position: 'CTO',
          headicon: './static/teamimgs/6.png',
          des: '创业，最大的魅力在于不确定的反馈'
        }, {
          name: '陈思钦',
          nick: '吉祥',
          position: '福泉区总裁',
          headicon: './static/teamimgs/7.png',
          des: '别回头，时代在改变'
        }, {
          name: '张洪',
          nick: '雷利',
          position: '惠水大区总裁',
          headicon: './static/teamimgs/8.png',
          des: '不知所措，才是人生'
        }, {
          name: '刘玲',
          nick: '刘玲',
          position: '花溪大区总裁',
          headicon: './static/teamimgs/9.png',
          des: '只需要鼓起勇气，认认真真去做就好了'
        }, {
          name: '赵柏林',
          nick: '狮子歌歌',
          position: '办公事业部总裁',
          headicon: './static/teamimgs/10.png',
          des: '人啊，一定会有机会出场的'
        }, {
          name: '王恒',
          nick: '王恒',
          position: '脚印科技事业部总裁',
          headicon: './static/teamimgs/11.png',
          des: '是时候表演真正的技术了'
        }],
      teamList: []
    }
  },
  created () {
    Api.changeClass = 4
    this.getTeamList()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },
    getTeamList () {
      let _this = this
      axios.get(Api.Market_BASE_URL + Api.getTeamList).then((response) => {
        console.log(response)
        _this.teamList = response.data.data
        console.log(_this.teamList)
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    }
  }
}

</script>

<style>
  .uses img{
    width: 100%;
  }
  .user{
    text-align: left;
    /*height: 150px;*/
    /*border-radius: 5px;border: solid black 1px;*/
    box-shadow: 1px 1px 1px 1px gray;
  }
  .nav-content {
    width: 100%;
    height: 80px;
    box-shadow: none;
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .block {
    position: relative;
  }

  .el-carousel {
    width: 100%;
    height: 550px;
  }

  .el-carousel img {
    width: 100%;
    height: 100%;
  }

  .is-active .el-carousel__button {
    background-color: #00f1ff;
  }

  .el-carousel__button {
    height: 5px;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .el-carousel__arrow:hover {
    background-color: #cf0631;
  }

  .main {
    width: 1200px;
  }

  .link-content {
    margin: 50px auto;
  }

  .link-content li {
    display: inline-block;
  }

  .link-content li a {
    display: inline-block;
    margin: 0px 20px;
    width: 180px;
    height: 45px;
    line-height: 45px;
    border-radius: 5px;
    color: #fff;
    font-size: 18px;
    background-color: #333333;
  }

  .link-content li a:hover {
    background-color: #fd3434;
  }

  .about-contain {
    margin-top: 30px;
    width: 1060px;
  }

  .about-title {
    width: 100px;
    height: 100px;
    /*border-radius: 50px;*/
    /*color: #fff;*/
    /*background-color: #333333;*/
    line-height: 100px;
    margin-bottom: 30px;
    font-size: 16px;
    margin-left: 10px;
  }

  .about-content {
    margin-bottom: 50px;
  }

  .about-content p {
    font-size: 14px;
    line-height: 30px;
    text-align: left;
    text-indent: 2em;
  }
  .about-content img{
    height: 80px;
    margin: auto;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }
  .team-contain{
    width: 100%;
    height: 350px;
    background-color: #fd3434;
    position: relative;
    margin-bottom: 40px;
  }
  .person-box,.person-box img{
    width: 350px;
    height: 350px !important;
    float: left;
  }
  .team-introduce{
    width: 630px;
    height: 350px;
    background-color: #ddd;
    position: absolute;
    top: 0;
    right: 0;
    padding: 40px 30px 30px 90px;
    text-align: left;
  }
  .team-introduce p{
    font-size: 24px;
    color: #333333;
    margin-bottom: 10px;
  }
  .team-introduce small{
    margin-left: 50px;
    font-size: 18px;
  }
  .team-introduce label{
    background-color: #fff;
    color: #fd3434;
    width: 160px;
    height: 80px;
    font-size: 32px;
    text-align: center;
    line-height: 80px;
    position: absolute;
    top: 20px;
    left: -50px;
    font-weight: bold;
  }
  .team-des{
    width: 100%;
    position: absolute;
    bottom: 20px;
    left: 0;
    text-align: right;
  }
  .team-des span{
    font-size: 24px;
    color: #fff;
    margin: 0px 10px;
  }
  .fixed-about-block{
    width: 100%;
    height: 145px;
    display: none;
  }
  .display-block{
    display: block;
  }
  .fixed-about-nav{
    position: fixed;
    top: 80px;
    left: 0px;
    width: 100%;
    z-index: 999;
    box-shadow:5px 5px 8px -3px rgba(0, 0, 0, 0.1);
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/About.vue